export const LOADING = 'loading'
export const AUTHENTICATED = 'authenticated'
export const DENIED = 'denied'
export const NOTIFRAME = 'notiframe'
